import type { ReactNode } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { loadable } from 'jotai/utils';
import { Settings } from 'lucide-react';
import { AppShell, Button } from '@higgins/ui';
import { msalInstance, signOut } from '../lib/msal';
import { meAtom, settingsOpenAtom } from '../store/atoms';
import helpContent from '../../docs/USERS.md?raw';

const meLoadable = loadable(meAtom);

/** Header gear — IT and Dev only, per the toolbar convention in the other apps.
    loadable() so the header renders before /api/me resolves. */
function SettingsGear() {
  const me = useAtomValue(meLoadable);
  const setOpen = useSetAtom(settingsOpenAtom);
  // Offline the settings can't be read or saved, so the gear waits for signal.
  if (me.state !== 'hasData' || !me.data.canManage || me.data.offline) return null;
  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={() => setOpen(true)}
      className="text-slate-500 hover:text-slate-900"
      title="Access settings"
      aria-label="Access settings"
    >
      <Settings className="h-4 w-4" />
    </Button>
  );
}

export default function Layout({ children }: { children: ReactNode }) {
  return (
    // No launcher — this is where it would lead.
    <AppShell
      title="Higgins Apps"
      subtitle="Your internal tools, one place"
      width="3xl"
      launcher={false}
      msal={msalInstance}
      onSignOut={signOut}
      help={helpContent}
      toolbar={<SettingsGear />}
      loadingText="Loading your apps…"
      version={import.meta.env.VITE_APP_VERSION}
    >
      {children}
    </AppShell>
  );
}
